
import React from "react";
import { toCurrency } from "../tools/currency";
import { toDate,toTime,ToShortDateTime } from "../tools/datetime";
import {fullServerAddress} from "../tools/config"


export const getReports = (fn)=>{
    fetch(fullServerAddress + '/api/reports/getSessions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data.data);
         })
       .catch(err => {
          console.log(err);
        });
}

export const getTillReports = (fn)=>{
    fetch(fullServerAddress + '/api/reports/getSessionsFromTill', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data.data);
         })
       .catch(err => {
          console.log(err);
        });
}


export const GetReportsToPi = (selectedReports,fn)=>{
    fetch(fullServerAddress + '/api/reports/GetReportsToPi', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({selectedReports})
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });
}




export const gridStartDate=(props)=>{   
    return (<span>
        {ToShortDateTime(props.StartDate)}
    </span>);
}

export const gridEndDate=(props)=>{ 
    return (<span>
        {ToShortDateTime(props.EndDate)}
    </span>);
}

export const gridGrossSessionTotal=(props)=>{ 
    return (<span>
        {toCurrency(props.GrossSessionTotal)}
    </span>);
}
export const gridNetSessionTotal=(props)=>{ 
    return (<span>
        {toCurrency(props.NetSessionTotal)}
    </span>);
}
export const gridItemSum=(props)=>{ 
    return (<span>
        {toCurrency(props.ItemSum)}
    </span>);
}
export const gridExtraSum=(props)=>{ 
    return (<span>
        {props.ExtraSum>0?toCurrency(props.ExtraSum):'-'}
    </span>);
}
export const gridDiscountSum=(props)=>{ 
    return (<span>
        {props.DiscountSum!==0?toCurrency(props.DiscountSum):'-'}
    </span>);
}
export const gridVAT=(props)=>{ 
    return (<span>
        {toCurrency(props.OtherPaymentTotal)}
    </span>);
}
export const gridNoVAT=(props)=>{ 
    return (<span>
        {props.NetSessionTotal-props.OtherPaymentTotal!=0?toCurrency(props.NetSessionTotal-props.OtherPaymentTotal):'-'}
    </span>);
}
export const gridPaymentType=(props)=>{ 
    return (<span>
        <font color="#600" >{props.DebitCardTotal>0?toCurrency(props.DebitCardTotal):' No Card '}</font>
        <font color="#060" >{props.CashTotal>0?' / '+toCurrency(props.CashTotal):' No Cash '}</font>
        <font color="#006" >{props.ChequesTotal>0?' / '+toCurrency(props.ChequesTotal):' '} </font>
    </span>);
}
export const reportsGrid = [
    {
        field: 'StartDate',
        headerText: 'Start Date',
        textAlign: 'right',
        width: '120',
        minWidth: '120',
        maxWidth: '120',
        allowEditing : false,
        template: gridStartDate,
    },
    {
        field: 'EndDate',
        headerText: 'End Date',
        textAlign: 'right',
        width: '120',
        minWidth: '120',
        maxWidth: '120',
        allowEditing : false,
        template: gridEndDate,
    },
    {
        field: 'ItemSum',
        headerText: 'Item Sum',        
        textAlign: 'Center',
        width: '90',
        minWidth: '90',
        template: gridItemSum,
        allowEditing : false,
    },
    {
        field: 'GrossSessionTotal',
        headerText: 'Gross Total',
        textAlign: 'right',
        width: '90',
        minWidth: '90',
        template: gridGrossSessionTotal,
        allowEditing : false,
    },
    {
        field: 'NetSessionTotal',
        headerText: 'Net Total',
        textAlign: 'Center',
        width: '90',
        minWidth: '90',
        template: gridNetSessionTotal,
    },
    {
        headerText: 'S.Charge',
        field: 'Extra Sum',
        textAlign: 'Center',
        width: '90',
        minWidth: '90',
        template: gridExtraSum,
        allowEditing : false,
    },
    {
        field: 'DiscountSum',
        headerText: 'Discount',
        textAlign: 'right',
        width: '90',
        minWidth: '90',
        template: gridDiscountSum,
        allowEditing : false,
    },
    {
        field: 'OtherPaymentTotal',
        headerText: 'With VAT',
        textAlign: 'right',
        width: '90',
        minWidth: '90',
        template: gridVAT,
        allowEditing : false,
    },
    {
        field: 'OtherPaymentTotal',
        headerText: 'No VAT',
        textAlign: 'right',
        width: '90',
        minWidth: '90',
        template: gridNoVAT,
        allowEditing : false,
    },
    {
        field: 'PaymentType',
        headerText: '(Card : Cash : Cheque)',
        textAlign: 'center',
        width: '250',
        minWidth: '180',
        template: gridPaymentType,
        allowEditing : false,
    },
    {
        field: 'IID',
        width: '0',
        IsPrimaryKey: true,
        Visible: false,
        allowEditing : false,
    },
];


export const reportsGridTill = [
    {
        field: 'StartDate',
        headerText: 'Start Date',
        textAlign: 'right',
        width: '120',
        minWidth: '120',
        maxWidth: '120',
        allowEditing : false,
        template: gridStartDate,
    },
    {
        field: 'EndDate',
        headerText: 'End Date',
        textAlign: 'right',
        width: '120',
        minWidth: '120',
        maxWidth: '120',
        allowEditing : false,
        template: gridEndDate,
    },
    {
        field: 'NetSessionTotal',
        headerText: 'Net Total',
        textAlign: 'Center',
        width: '90',
        minWidth: '90',
        template: gridNetSessionTotal,
    },
    {
        headerText: 'S.Charge',
        field: 'Extra Sum',
        textAlign: 'Center',
        width: '90',
        minWidth: '90',
        template: gridExtraSum,
        allowEditing : false,
    },
    {
        field: 'DiscountSum',
        headerText: 'Discount',
        textAlign: 'right',
        width: '90',
        minWidth: '90',
        template: gridDiscountSum,
        allowEditing : false,
    },
    {
        field: 'IID',
        width: '0',
        IsPrimaryKey: true,
        Visible: false,
        allowEditing : false,
    },
];

export const gridOrderStatus = (props) => {
    let xy = StatusBg[props.Status];
    
    return (<span
        style={{ background: xy.StatusBg }}
        className="text-white py-1 px-2 capitalize rounded text-md"
    >
        {xy.Status}
    </span>);
};

export const gridOrderType=(props)=>{
    let xy = typeBg[props.OrderType];
    return (<span
        style={{ background: xy.StatusBg }}
        className="text-white py-1 px-2 capitalize rounded text-md"
    >
        {xy.Status}
    </span>);
}


export const gridOrderPaid=(props)=>{
    let xy = PaidBg[props.Payment];
    return (<span
        style={{ background: xy.StatusBg }}
        className="text-white py-1 px-2 capitalize rounded text-md"
    >
        {xy.Status}
    </span>);
}

export const gridOrderDate=(props)=>{    
    //console.log(props.OrderDate)
    return (<span>
        {(props.OrderDate)}
    </span>);
}

export const gridPrice=(props)=>{    
    return (<span>
        {toCurrency(props.total)}
    </span>);
}

export const gridItemPrice=(props)=>{    
    return (<span>
        {toCurrency(props.Price)}
    </span>);
}
export const gridItemTotal=(props)=>{    
    return (<span>
        {toCurrency(props.Price*props.Quantity)}
    </span>);
}
export const ordersGrid = [
    {
        field: 'OrderDate',
        headerText: 'Order Date',
        textAlign: 'Left',
        width: '130',
        allowEditing : false,
        template: gridOrderDate,
    },{
        field: 'total',
        headerText: 'Total',
        textAlign: 'right',
        width: '70',
        template: gridPrice,
        allowEditing : false,
    },
    {
        field: 'OrderType',
        headerText: 'Order Type',
        textAlign: 'Center',
        width: '90',
        template: gridOrderType,
    },
    {
        field: 'Payment',
        headerText: 'Payment type',        
        textAlign: 'Center',
        width: '70',
        template: gridOrderPaid,
        allowEditing : false,
    },
    {
        headerText: 'Status',
        field: 'Status',
        textAlign: 'Center',
        width: '90',
        template: gridOrderStatus,
        allowEditing : false,
    },

    {
        field: 'TableName',
        headerText: 'Table Name',
        textAlign: 'Left',
        width: '50',
        allowEditing : false,
    },
    {
        field: 'UserName',
        headerText: 'Staff',
        textAlign: 'Left',
        width: '80',
        allowEditing : false,
    },
    {
        field: 'IID',
        width: '0',
        IsPrimaryKey: true,
        Visible: false,
        allowEditing : false,
    },
];

export const modelOrdersGrid = [
    {
        field: 'OrderDate',
        headerText: 'Order Date',
        textAlign: 'Left',
        width: '130',
        allowEditing : false,
        template: gridOrderDate,
    },{
        field: 'total',
        headerText: 'Total',
        textAlign: 'right',
        width: '70',
        template: gridPrice,
        allowEditing : false,
    },
    {
        field: 'OrderType',
        headerText: 'Order Type',
        textAlign: 'Center',
        width: '90',
        template: gridOrderType,
    },
    {
        field: 'Payment',
        headerText: 'Payment type',        
        textAlign: 'Center',
        width: '70',
        template: gridOrderPaid,
        allowEditing : false,
    },
    {
        headerText: 'Status',
        field: 'Status',
        textAlign: 'Center',
        width: '90',
        template: gridOrderStatus,
        allowEditing : false,
    },

    {
        field: 'TableName',
        headerText: 'Table Name',
        textAlign: 'Left',
        width: '50',
        allowEditing : false,
    },
    {
        field: 'IID',
        width: '0',
        IsPrimaryKey: true,
        Visible: false,
        allowEditing : false,
    },
];


export const orderItemsGrid = [
    {
        field: 'EntityName',
        headerText: 'Main Item',
        textAlign: 'Left',
        width: '100',
        allowEditing : false,
    },{
        field: 'OrderItemText',
        headerText: 'Name',
        textAlign: 'Left',
        width: '150',
        allowEditing : false,
    },{
        field: 'Quantity',
        headerText: 'Quantity',
        textAlign: 'Left',
        width: '50',
        allowEditing : false,
    },{
        field: 'Price',
        headerText: 'Price',
        textAlign: 'Left',
        width: '50',
        template: gridItemPrice,
        allowEditing : false,
    },{
        field: 'total',
        headerText: 'Total',
        textAlign: 'Left',
        width: '50',
        template: gridItemTotal,
        allowEditing : false,
    },
    {
        field: 'IID',
        width: '0',
        IsPrimaryKey: true,
        Visible: false,
        allowEditing : false,
    },
]


export const GetPadItemsData = (fn)=>{
    fetch(fullServerAddress + '/api/menu/GetEntityPADButtons', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((res) => res.json())
      .then((data) => {
          let x = data.data.map((item, index) => {
              return {
                  //EntityName: item.EntityName,
                  text: item.EntityButtonName,
                  //EntityDisplayOrder: item.EntityDisplayOrder,
                  //DisplayOrder: item.DisplayOrder,
                  //DirectSaleTaxPercent : item.DirectSaleTaxPercent,
                  //EntityIID: item.EntityIID,
                  value:item.IID,
              };
          });
          fn(x);
         })
       .catch(err => {
          //ShowToast('server Error!!')
          console.log(err);
        });
}


export const ordersData = (fn)=>{

    fetch(fullServerAddress + '/api/reports/getOrders', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then((res) => res.json())
        .then((data) => {
            let x = data.map((item, index) => {
                return {
                    OrderDate: ToShortDateTime(item.OrderDate),
                    OrderType: item.OrderType,
                    Payment: item.Payment,
                    Status: item.Status,
                    UserName: item.UserName,
                    TableName: item.TableName,
                    IID:item.IID,
                    WVat:item.WVat,
                    NVat:item.NVat,
                    vat:item.vat,
                    total:item.Total,
                    sub:item.sub,
                    
                };
            });




          //console.log(x)
          fn(x);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });

}

/* */


export const StatusBg = {
    0: {
        Status: 'New',
        StatusBg: '#FEC90F',
    },
    1: {
        Status: 'Open',
        StatusBg: '#8BE78B',
    },
    2: {
        Status: 'Done',
        StatusBg: '#FF5C8E',
    },
    3: {
        Status: 'Paid',
        StatusBg: '#03C9D7',
    },
    4: {
        Status: 'Archived',
        StatusBg: '#999999',
    }
};


export const typeBg = {
    0: {
        Status: 'Unknown',
        StatusBg: '#CCCCCC',
    },
    1: {
        Status: 'In-House',
        StatusBg: '#0C2D48',
    },
    256: {
        Status: 'Takeaway',
        StatusBg: '#000C66',
    }
};

export const PaidBg = {
    0: {
        Status: 'UnPaid',
        StatusBg: '#cccccc',
    }, 
    1: {
        Status: 'Cash',
        StatusBg: '#00cc00',
    }, 
    2: {
        Status: 'CreditCard',
        StatusBg: '#122620',
    },
    3:{
        Status: 'Card',
        StatusBg: '#B68D20',
    },
    4:{
        Status: 'Cheque',
        StatusBg: '#8BE78B',
    }
};

export const FixOrders = (pIID,idList, fn)=>{
    fetch(fullServerAddress + '/api/reports/FixOrders', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({pIID,idList})
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });
}


